module.exports = __webpack_public_path__ + "img/12.0dc07c4f.png";